export default __webpack_public_path__ + "static/media/pasc_logo.044b3859.png";